"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.to-string.js");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _FormInputFancyCheckboxElement = _interopRequireDefault(require("./FormInputFancyCheckboxElement"));
var _InputError = _interopRequireDefault(require("./InputError"));
var _InputHelpText = _interopRequireDefault(require("./InputHelpText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FormInputFancyCheckbox = props => {
  const {
    colSize
  } = props;
  let colLength1;
  let colLength2;
  if (colSize === 0) {
    colLength1 = "col-sm-4";
    colLength2 = "col-sm-8";
  }
  if (colSize === 1) {
    colLength1 = "col-sm-12";
    colLength2 = "col-sm-12";
  }
  if (colSize === 2) {
    colLength1 = "col-sm-4";
    colLength2 = "col-sm-8";
  }
  if (colSize === 3) {
    colLength1 = "col-sm-4";
    colLength2 = "col-sm-8";
  }
  if (colSize === 4) {
    colLength1 = "col-sm-4";
    colLength2 = "col-sm-8";
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-".concat(props.divColSize)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container p-0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group row border-bottom pb-2"
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: props.name,
    className: colLength1
  }, props.label), /*#__PURE__*/_react.default.createElement("div", {
    className: colLength2
  }, props.checkboxData ? props.checkboxData.map((options, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "form-check form-check-inline"
    }, /*#__PURE__*/_react.default.createElement("label", {
      className: "form-check-label text-left btn btn-outline-primary mb-2",
      htmlFor: props.name + index
    }, /*#__PURE__*/_react.default.createElement(_FormInputFancyCheckboxElement.default, {
      className: (0, _classnames.default)("form-check-input", {
        "is-invalid": props.error
      }),
      type: "checkbox",
      checked: props.value.indexOf("," + options.id.toString() + ",") !== -1 ? "checked" : null,
      name: props.name,
      id: props.name + index,
      value: options.id,
      selectedCheckboxes: props.selectedCheckboxes,
      handleCheckboxChange: props.handleCheckboxChange
    }), options.name));
  }) : null), /*#__PURE__*/_react.default.createElement(_InputError.default, {
    error: props.error
  }), /*#__PURE__*/_react.default.createElement(_InputHelpText.default, {
    helpText: props.helpText
  }))));
};
var _default = FormInputFancyCheckbox;
exports.default = _default;